export default {
  meeting: {
    is: 'Mæta á fund',
    en: 'Appointment',
  },

  phoneCall: {
    is: 'Fá símtal',
    en: 'Phone call',
  },

  videoCall: {
    is: 'Fjarfundur',
    en: 'Virtual meeting',
  },

  pickAccess: {
    is: 'Veldu símtal/fund',
    en: 'Select phonecall/meeting',
  },

  pickBranch: {
    is: 'Veldu útibú',
    en: 'Select branch',
  },

  pickDate: {
    is: 'Veldu dagsetningu og tíma',
    en: 'Select date and time',
  },

  pickType: {
    is: 'Veldu tegund þjónustu',
  },

  pickService: {
    is: 'Veldu þjónustu',
    en: 'Select service',
  },

  continue: {
    is: 'Áfram',
    en: 'Continue',
  },

  phoneCallDisabled: {
    is: 'Viðtalið er í formi símtals',
  },
};
